// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__2x8A3","author":"Table_author__31Lzr","authorImage":"Table_authorImage__2zU2z","unreadRow":"Table_unreadRow__2itGz"};